import { Button } from "@screencloud/screencloud-ui-components";
import { FunctionComponent, ReactElement } from "react";
import "./ErrorLogin.scss";

export const ErrorLogin: FunctionComponent = (): ReactElement => {
  const handleCloseClick = () => {
    window.close();
  };
  return (
    <div className="error-container">
      <h1>Sorry we seem to be having some trouble.</h1>
      <h1>Please try to login again.</h1>
      <Button primary onClick={handleCloseClick}>
        Close
      </Button>
    </div>
  );
};
